import React, { ReactNode } from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import { InfoOutlined, CheckCircleOutline } from '@mui/icons-material';
import { InfoMessageVariant } from 'types';

type Props = {
  title: string;
  message?: ReactNode;
  fullWidth?: boolean;
  variant?: InfoMessageVariant;
};

export const InfoMessage = ({ title, message, fullWidth, variant = 'info' }: Props) => {
  const infoType = {
    default: {
      backgroundColor: 'grey.50',
      Icon: () => null,
    },
    success: {
      backgroundColor: 'success.light',
      Icon: () => <CheckCircleOutline sx={{ my: 2, mr: 3, color: 'success.dark' }} />,
    },
    error: {
      backgroundColor: 'error.light',
      Icon: () => <InfoOutlined sx={{ my: 2, mr: 3, color: 'error.dark' }} />,
    },
    warning: {
      backgroundColor: 'warning.light',
      Icon: () => <InfoOutlined sx={{ my: 2, mr: 3, color: 'warning.dark' }} />,
    },
    info: {
      backgroundColor: 'blue.50',
      Icon: () => <InfoOutlined sx={{ my: 2, mr: 3, color: 'blue.800' }} />,
    },
  };

  const { backgroundColor, Icon } = infoType[variant];

  return (
    <Paper
      sx={{
        backgroundColor,
        px: 4,
        py: 1.5,
        borderRadius: 2 / 3,
        width: { xs: 1, lg: fullWidth ? 1 : 2 / 3 },
      }}
    >
      <Stack direction="row">
        <Icon />
        <Stack sx={{ py: 2 }} gap={1}>
          <Typography variant="h4">{title}</Typography>
          {message}
        </Stack>
      </Stack>
    </Paper>
  );
};
